import apiClient from './client';
import { avatarsApiUrl, avatarSelectApiUrl } from '../utils/runtime';
import { normalizePlayerAvatarPayload } from '../avatar/playerAvatar.mjs';

function withNoCache(url) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_pfp_avatar_ts=${Date.now()}`;
}

export async function fetchMyAvatars() {
  const url = avatarsApiUrl || '/wp-json/pfandpirat/v1/me/avatars';
  const data = await apiClient.get(withNoCache(url));
  return normalizePlayerAvatarPayload(data);
}

export async function selectMyAvatar(avatarId) {
  const url = avatarSelectApiUrl || '/wp-json/pfandpirat/v1/me/avatar/select';
  const data = await apiClient.post(url, { avatar_id: Number(avatarId) });

  return normalizePlayerAvatarPayload({ message: 'Avatar gespeichert.', ...data });
}

export default {
  fetchMyAvatars,
  selectMyAvatar,
};
